module.exports = __webpack_public_path__ + "img/xjfhcl_s.5a64ed0.png";